// extracted by mini-css-extract-plugin
export default {"notice":"CookieNotice__notice___gLLdK","btn":"CookieNotice__btn___ISWr6"};